import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CorporateUser, EntityTypes, JobOrder, JobSubmission } from "@bullhorn/bullhorn-types";
import { EntityPickerResult, EntityPickerResults, FormUtils, NovoAsideService, NovoModalRef, NovoModalService, PickerControl, PickerResults, QuickNoteControl, TextAreaControl, TextBoxControl } from "novo-elements";
import { UserSettings } from "src/app/interfaces/bullhorn";
import { AppBridgeService } from "src/app/services/appBridge.service";
import { AppBridgeTargetService } from "src/app/services/appBridgeTarget.service";
import { HttpService } from "src/app/services/http.service";
import { HttpTargetService } from "src/app/services/httpTarget.service";
import { MetaService } from "src/app/services/meta.service";

@Component({
  selector: 'demo-page',
  templateUrl: './add-target.component.html',
  styleUrls: ['./add-target.component.scss']
})
export class DemoPageComponent {
  public loading = true;
  public connected = true;
  public textControl: any;
  public candidatePickerControl: any;
  public ownerPickerControl: any;
  public jobOrderPickerControl: any;
  public commentsControl: QuickNoteControl;
  public textForm: any;
  public fieldConfig;
  public dynamic: any;
  public jobOrder: JobOrder | any;
  public submission: JobSubmission | any;
  public fromUser: CorporateUser | any;
  public dynamicForm: any;
  constructor(private appBridgeService: AppBridgeTargetService, private httpService: HttpTargetService, private formUtils: FormUtils, private meta: MetaService, private route: ActivatedRoute) {
    document.documentElement.className = 'custom-menu-item';
    this.formUtils = formUtils;
  }

  ngOnInit() {
    this.onRegistered(true);
  }


  private async onRegistered(isRegistered, ...args) {
    if (isRegistered) {
      this.loading = false;

        this.textControl = new TextBoxControl({ key: 'summary', label: 'Summary', readOnly: true, value: ``});
        this.jobOrderPickerControl = new PickerControl({
          key: 'jobOrder',
          multiple: true,
          label: 'Job Order',
          required: true,
          readOnly: true,
          config: {
            format: '$label',
            previewTemplate: EntityPickerResult,
            resultsTemplate: EntityPickerResults,
            type: 'JobOrder',
            options: [{
              searchEntity:'JobOrder', 
              value: 'Apple',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, 
            {
              searchEntity:'JobOrder', 
              value: 'Banana',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, 
            {
              searchEntity:'JobOrder', 
              value: 'Grapes',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, {
              searchEntity:'JobOrder', 
              value: 'Orange',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, {
              searchEntity:'JobOrder',
              value: 'Pear',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }],
          },
        });
        this.candidatePickerControl = new PickerControl({
          key: 'candidates',
          multiple: true,
          label: 'Candidate',
          required: true,
          readOnly: true,
          config: {
            format: '$label',
            previewTemplate: EntityPickerResult,
            resultsTemplate: EntityPickerResults,
            type: 'Candidate',
            options: [{
              searchEntity:'Candidate', 
              value: 'Apple',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, 
            {
              searchEntity:'Candidate', 
              value: 'Banana',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, 
            {
              searchEntity:'Candidate', 
              value: 'Grapes',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, {
              searchEntity:'Candidate', 
              value: 'Orange',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, {
              searchEntity:'Candidate',
              value: 'Pear',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }],
          },
        });
        this.ownerPickerControl = new PickerControl({
          key: 'owner',
          multiple: true,
          label: 'Candidate Recruiter',
          required: true,
          readOnly: true,
          config: {
            format: '$label',
            previewTemplate: EntityPickerResult,
            resultsTemplate: EntityPickerResults,
            type: 'User',
            options: [{
              searchEntity:'CorporateUser', 
              value: 'Apple',
              firstName: 'Charles',
              lastName: 'Barnes',
              name: 'Charles Barnes',
              label: 'Charles Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, 
            {
              searchEntity:'CorporateUser', 
              value: 'Banana',
              firstName: 'Charles',
              lastName: 'Barnes',
              name: 'Charles Barnes',
              label: 'Charles Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, 
            {
              searchEntity:'CorporateUser', 
              value: 'Grapes',
              firstName: 'Charles',
              lastName: 'Barnes',
              name: 'Charles Barnes',
              label: 'Charles Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, {
              searchEntity:'CorporateUser', 
              value: 'Orange',
              firstName: 'Charles',
              lastName: 'Barnes',
              name: 'Charles Barnes',
              label: 'Charles Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, {
              searchEntity:'CorporateUser',
              value: 'Pear',
              firstName: 'Charles',
              lastName: 'Barnes',
              name: 'Charles Barnes',
              label: 'Charles Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }],
          },
        });
        this.commentsControl = new QuickNoteControl({ 
          key: 'comments', 
          label: 'Comments',
          config: {
            triggers: {
            },
            options: {
            },
            renderer: {
            },
          }
        });
        this.textForm = this.formUtils.toFormGroup([this.textControl, this.candidatePickerControl, this.ownerPickerControl, this.commentsControl, this.jobOrderPickerControl]);
  
      //this.dynamicForm = this.formUtils.toFormGroupFromFieldset(this.dynamic);
    } else {
      this.connected = false;
      this.loading = false;
    }
  } 

}